var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-data-editor',{attrs:{"id":_vm.id,"title":"Редактирование Клиента","resource":"clients","elements":_vm.elements,"add-message":"Клиент добавлен","edit-message":"Клиент изменен"}})
}
var staticRenderFns = []

export { render, staticRenderFns }